import React from 'react';
import CarouselsContainer from '../../Componant/Bonus-Ui/Carousel';

const Carousels = () => {
  return (
    <div className='page-body'>
      <CarouselsContainer />
    </div>
  );
};

export default Carousels;
